import { MergeDecisionTypeId as MergeDecisionTypeId$1, Done as Done$1, Await as Await$1, AwaitConst as AwaitConst$1, isMergeDecision as isMergeDecision$1, match as match$1 } from '../../internal/channel/mergeDecision.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const MergeDecisionTypeId = MergeDecisionTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const Done = Done$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const Await = Await$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const AwaitConst = AwaitConst$1;

/**
 * Returns `true` if the specified value is a `MergeDecision`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isMergeDecision = isMergeDecision$1;

/**
 * @since 2.0.0
 * @category folding
 */
const match = match$1;

export { Await, AwaitConst, Done, MergeDecisionTypeId, isMergeDecision, match };
